import { useLingui } from "@lingui/react/macro";
import { useId } from "react";

import { formatGameTime } from "@/features/analysis";

import type { DrillAnswer, DrillSpec } from "../../model/Drill";
import { TIME_STEP_S } from "../../model/TIME_STEP_S";

type ValueSliderProps = {
  spec: DrillSpec;
  answer: DrillAnswer;
  locked: boolean;
  onChange: (answer: DrillAnswer) => void;
};

// Ползунок времени матча: значение крупно над шкалой, подписи краёв и середины.
export const ValueSlider = ({ spec, answer, locked, onChange }: ValueSliderProps) => {
  const { t } = useLingui();
  const id = useId();
  const min = spec.min_value ?? 0;
  const max = spec.max_value ?? 0;
  const value = answer.value ?? min;
  const format = formatGameTime;
  return (
    <div className="flex flex-col gap-2.5">
      <label htmlFor={id} className="flex items-baseline justify-between text-sm text-muted">
        <span>{t`Your answer`}</span>
        <span className="font-mono text-2xl font-semibold text-accent">{format(value)}</span>
      </label>
      <input
        id={id}
        type="range"
        min={min}
        max={max}
        step={TIME_STEP_S}
        value={value}
        disabled={locked}
        aria-valuetext={format(value)}
        onChange={(event) => {
          onChange({ ...answer, value: Number(event.target.value) });
        }}
        className="h-8 w-full accent-accent"
      />
      <div className="flex justify-between font-mono text-xs text-subtle">
        <span>{format(min)}</span>
        <span>{format((min + max) / 2)}</span>
        <span>{format(max)}</span>
      </div>
    </div>
  );
};
